import { 
  VehiculosImportadora, 
  ServiciosPintura, 
  CostosVehiculos,
  VehicleCatalog
} from "components/Importadora";

const routesImportadora = [
  {
    path: "/vehiculos-catalogo",
    name: "Catalogo de Vehiculos",
    icon: "nc-icon nc-delivery-fast",
    component: <VehicleCatalog />,
    permissions: ['145_MODULO_IMPORTADORA', '49_ADMIN'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  },
  {
    path: "/servicios-pintura",
    name: "Servicios Pintura",
    icon: "nc-icon nc-palette",
    component: <ServiciosPintura />,
    permissions: ['IMPORTADORA', 'ADMIN'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  },
  {
    path: "/costos-vehiculos",
    name: "Costos Vehiculos",
    icon: "nc-icon nc-bank",
    component: <CostosVehiculos />,
    permissions: ['IMPORTADORA', 'ADMIN'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  },
]

export {
    routesImportadora
}